"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _cnbuilder = require("cnbuilder");
var _reactI18next = require("react-i18next");
var _alertDefault = _interopRequireDefault(require("@teladoc/pulse/icons/alert-default.svg"));
var _infoDefault = _interopRequireDefault(require("@teladoc/pulse/icons/info-default.svg"));
var _DismissButton = _interopRequireDefault(require("../DismissButton"));
var _BannerModule = _interopRequireDefault(require("./Banner.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
const ICONS = {
  info: _infoDefault.default,
  error: _alertDefault.default,
  warning: _alertDefault.default
};
const Banner = _ref => {
  let {
    className,
    testAttrRoot,
    testAttrDismiss,
    variant,
    children,
    showDismiss,
    i18nDismissLabel,
    onDismissClick
  } = _ref;
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const Icon = ICONS[variant];
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: (0, _cnbuilder.cnb)(_BannerModule.default.root, {
      [_BannerModule.default[variant]]: variant
    }, className),
    "data-testid": testAttrRoot,
    role: "alert",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: _BannerModule.default.container,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: _BannerModule.default.content,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(Icon, {
          className: _BannerModule.default.icon,
          "aria-hidden": true
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: "visually-hidden",
          "aria-hidden": true,
          children: t("ui:banner.".concat(variant))
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: _BannerModule.default.message,
          children: children
        })]
      }), showDismiss && variant !== 'error' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_DismissButton.default, {
        className: _BannerModule.default.dismiss,
        testAttr: testAttrDismiss,
        i18nLabel: i18nDismissLabel || t('ui:banner.dismiss'),
        inverse: variant !== 'warning',
        onClick: onDismissClick
      })]
    })
  });
};
Banner.defaultProps = {
  testAttrRoot: 'banner-root',
  testAttrDismiss: 'banner-dismiss',
  variant: 'info',
  showDismiss: true
};
var _default = exports.default = Banner;